import FormDialog from "../../helpers/FormDialog";
import { Provinces, Districts, Sectors, Cells, Villages } from "rwanda";
import { useState, useEffect } from "react";

export default function CurrentResidenceEdit({ open, onSuccess, setOpen, id, value, setValue0 }) {
  const [fatherLocationData, setFatherLocationData] = useState({
    provinces: Provinces(),
    districts: [],
    sectors: [],
    cells: [],
    villages: [],
  });

  useEffect(() => {
    if (open) {

      // Initialize Father's Location
      const initializeLocation = () => {
        const fp = value.province;
        if (fp) {
          const districts = Districts(fp);
          const fd = value.district;
          const sectors = fd ? Sectors(fp, fd) : [];
          const fs = value.sector;
          const cells = fs ? Cells(fp, fd, fs) : [];
          const fc = value.cell;
          const villages = fc ? Villages(fp, fd, fs, fc) : [];

          setFatherLocationData(prev => ({
            ...prev,
            districts,
            sectors,
            cells,
            villages
          }));
        }
      };    

      initializeLocation();
    }
  }, [open, value]);
  const fields = [

    {
      name: "residence",
      label: "Current Residence",
      type: "group",
      fields: [
        
        {
          name: "province",
          label: "Province",
          type: "select",
          value: value["province"],
          required: true,
          values: fatherLocationData.provinces.map((province) => ({
            label: province,
            value: province,
          })),
          setValue: (val) => {
            const districts = Districts(val);
            setFatherLocationData((prev) => ({
              ...prev,
              districts,
              sectors: [],
              cells: [],
              villages: [],
            }));
            setValue0("province", val);
            setValue0("district", "");
            setValue0("sector", "");
            setValue0("cell", "");
            setValue0("village", "");
          },
        },
        {
          name: "district",
          label: "District",
          type: "select",
          value: value["district"],
          required: true,
          values: fatherLocationData.districts.map((district) => ({
            label: district,
            value: district,
          })),
          setValue: (val) => {
            const sectors = Sectors(value["province"], val);
            setFatherLocationData((prev) => ({
              ...prev,
              sectors: sectors || [],
              cells: [],
              villages: [],
            }));
            setValue0("district", val);
            setValue0("sector", "");
            setValue0("cell", "");
            setValue0("village", "");
          },
        },
        {
          name: "sector",
          label: "Sector",
          type: "select",
          value: value["sector"],
          required: true,
          values: fatherLocationData.sectors.map((sector) => ({
            label: sector,
            value: sector,
          })),
          setValue: (val) => {
            const cells = Cells(value["province"], value["district"], val);
            setFatherLocationData((prev) => ({
              ...prev,
              cells: cells || [],
              villages: [],
            }));
            setValue0("sector", val);
            setValue0("cell", "");
            setValue0("village", "");
          },
        },
        {
          name: "cell",
          label: "Cell",
          type: "select",
          value: value["cell"],
          required: true,
          values: fatherLocationData.cells.map((cell) => ({
            label: cell,
            value: cell,
          })),
          setValue: (val) => {
            const villages = Villages(
              value["province"],
              value["district"],
              value["sector"],
              val
            );
            setFatherLocationData((prev) => ({
              ...prev,
              villages: villages || [],
            }));
            setValue0("cell", val);
            setValue0("village", "");
          },
        },
        {
          name: "village",
          label: "Village",
          type: "select",
          value: value["village"],
          required: true,
          values: fatherLocationData.villages.map((village) => ({
            label: village,
            value: village,
          })),
          setValue: (val) => setValue0("village", val),
        },
        {
          name: "houseNo",
          label: "House No",
          type: "text",
          value: value["houseNo"],
          required: true,
          setValue: (val) => setValue0("houseNo", val),
        },
        {
          name: "villageLeaderName",
          label: "Village Leader Name",
          type: "text",
          value: value["villageLeaderName"],
          required: true,
          setValue: (val) => setValue0("villageLeaderName", val),
        },
        {
          name: "villageLeaderMobile",
          label: "Village Leader Phone",
          type: "tel",
          value: value["villageLeaderMobile"],
          required: true,
          setValue: (val) => setValue0("villageLeaderMobile", val),
        },

      ],
    },
   
  ];

  return (
    <FormDialog
      maxWidth={"md"}
      open={open}
      onSuccess={onSuccess}
      setOpen={setOpen}
      url={open === 1 ? "/api/resource/create" : `/api/resource/current-residence/update/${id}`}

    //   url={open === 1 ? "/api/resource/create" : `/api/resource/parent-info/update/${resourceId}`}
      title={open === 1 ? "Create Current Residence Details" : "Edit Current Residence"}
      fields={fields}
    />
  );
}